import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { Typography } from "@tosize/ui";
import { useIntl } from "react-intl";
import { useNavigation } from "../../../hooks/useNavigation";
import FloatingButton from "../../FloatingButton";

interface MenuTitleBlockProps {
	surtitle?: string;
	title?: string;
}

export default function MenuTitleBlock(props: MenuTitleBlockProps) {
	const { surtitle, title } = props;
	const intl = useIntl();

	const { navigate } = useNavigation();

	return (
		<div className="mb-4 flex items-center leading-none">
			<div className="mr-4">
				<Typography variant="paragraph-italic" color="text-secondary" className="leading-none">
					{surtitle}
				</Typography>
				<Typography
					variant="paragraph-primary-extrabold"
					color="text-primary-medium"
					size="text-lg"
					className="mt-1 leading-none"
				>
					{title}
				</Typography>
			</div>

			<div className="absolute top-[-10px] right-[-10px] hidden xl:block">
				<FloatingButton
					icon={faTimes}
					size="extra-small"
					title={intl.formatMessage({ defaultMessage: "Venster sluiten", id: "jLxEJw" })}
					onClick={() => navigate(null)}
				/>
			</div>
		</div>
	);
}
